import React, { useState } from "react";
import { InlineMath } from "react-katex";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { MathComponent } from "mathjax-react";
// import Iframe from "react-iframe";
import MediaQuery from "react-responsive";
import VideoPlayer from "react-video-js-player";
import Vid3 from "./Vid3.mp4"
const Chtambahan = ({ukuranH,ukuranP}) => {
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	// const [show4, setShow4] = useState(false);
	// const [show5, setShow5] = useState(false);

	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="container mb-3"
		>
			<div className="text-center">
				<p style={{fontSize:`${ukuranP}px`}}>
					Tentukan Daerah Penyelesaian dari sistem pertidaksamaan linear
					dua variabel&nbsp;&nbsp;&nbsp;
					<InlineMath math="2x + 2y ≤ 10; \space" />
					<InlineMath math="3x + y ≤ 6; " />
					&nbsp;&nbsp;&nbsp;untuk x dan y anggota R !
				</p>
			</div>
			<div
				style={{
					color: "green",
					display: "flex",
					justifyContent: "space-between",
					width: "10%",
				}}
			>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipNextIcon />
				</div>
				<p style={{ marginLeft: "22px" }}>
					<strong>
						<u>Jawaban</u>
					</strong>
				</p>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipPreviousIcon />
				</div>
			</div>
			<div>
				<ul style={{fontSize:`${ukuranP}px`}}>
					<li>
						Untuk <MathComponent tex={String.raw`2x + 2y ≤ 10`} />
					</li>
					<div className="d-flex justify-content-center">
						<button
							className="btn btn-success btn-sm mb-2"
							onClick={() => setShow1(true)}
						>
							Lanjut
						</button>
					</div>
					{show1 ? (
						<>
							<div className="text-center">
								Lalu kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>
								
							</div>
							<div className="d-flex justify-content-center"><InlineMath math="2x + 2y = 10"/> </div>
							<div class="d-flex justify-content-center">
								<table
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "30%",
										textAlign: "center",
									}}
								>
									<tr>
										<th
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>x</i>
										</th>
										<th
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>y</i>
										</th>
										<th
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>(x,y)</i>
										</th>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>
												<InlineMath math="5" />
											</i>
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>0</i>
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>
												<InlineMath math="(5 , 0)" />
											</i>
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>0</i>
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>
												<InlineMath math="5" />
											</i>
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<i>
												<InlineMath math="(0 , 5)" />
											</i>
										</td>
									</tr>
								</table>
							</div>
							<p className="text-center">Maka kita dapatkan :</p>
							<p className="text-center">Titik Koordinat A = <InlineMath math=" (5,0) "/></p>
							<p className="text-center">Titik Koordinat B = <InlineMath math=" (0,5) "/></p>
							<div className="d-flex justify-content-center">
								<button
									className="btn btn-success btn-sm mb-2 mt-2"
									onClick={() => setShow2(true)}
								>
									Lanjut
								</button>
							</div>
							{show2 ? (
								<>
									<li>
									Untuk <MathComponent tex={String.raw`3x + y ≤ 6`} />
									</li>
													<div className="text-center">
													Lalu kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>
													</div>
													<div className="d-flex justify-content-center"><InlineMath math="3x + y = 6"/> </div>
													<div class="d-flex justify-content-center">
														<table
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
																width: "30%",
																textAlign: "center",
															}}
														>
															<tr>
																<th
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>x</i>
																</th>
																<th
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>y</i>
																</th>
																<th
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>(x,y)</i>
																</th>
															</tr>
															<tr>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>
																		<InlineMath math="2" />
																	</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>0</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>
																		<InlineMath math="(2 , 0)" />
																	</i>
																</td>
															</tr>
															<tr>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>0</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>
																		<InlineMath math="6" />
																	</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>
																		<InlineMath math="(0 , 6)" />
																	</i>
																</td>
															</tr>
														</table>
													</div>
													<p className="text-center">Maka kita dapatkan :</p>
							<p className="text-center">Titik Koordinat C = <InlineMath math=" (2,0) "/></p>
							<p className="text-center">Titik Koordinat D = <InlineMath math=" (0,6) "/></p>
									<div className="d-flex justify-content-center">
										<button
											className="btn btn-success btn-sm mb-2 mt-2"
											onClick={() => setShow3(true)}
										>
											Lanjut
										</button>
									</div>
									{show3 ? (
										<>
											<div>
												<ul>
												<p>
																		Coba kamu perhatikan video yang  di bawah ini, agar kamu mengerti&nbsp;&nbsp;
																		<strong>
																			daerah penyelesaian
																		</strong>&nbsp;&nbsp; dari{" "}&nbsp;&nbsp;
																		<InlineMath math=" 2x + 2y ≤ 10; " />
																		<InlineMath math=" 3x + y ≤ 6; " />
																	</p>
																											
												</ul>
											</div>
											<div className="d-flex justify-content-center">
											<MediaQuery minWidth={476} maxWidth={1824}>
																<VideoPlayer 
																src={Vid3}
																width="800"
																height="500"
																/>
																</MediaQuery>
																<MediaQuery maxWidth={475}>
																<VideoPlayer 
																src={Vid3}
																width="300"
																height="100"
																/>
																</MediaQuery>
											</div>
											<div className="text-center"><b><i>Video cara mencari daerah penyelesaian dari sistem pertidaksamaan linear dua variabel</i></b></div>
										</>
									) : null}
								</>
							) : null}
						</>
					) : null}
				</ul>
			</div>
		</div>
	);
};

export default Chtambahan;
